<template>
  <v-hover v-slot:default="{hover}">
    <v-card :class="{ 'on-hover': hover}">
      <v-img
        :src="$assets.meeroThumbnail(orderId, image.id)"
        height="250"
        lazy-src="../../assets/lazy-src.jpg"
      >
        <template v-slot:placeholder>
          <v-row class="fill-height ma-0" align="center" justify="center">
            <v-progress-circular indeterminate color="red"></v-progress-circular>
          </v-row>
        </template>
        <v-container fluid class="fill-height">
          <v-row no-gutters align="start" class="fill-height" v-if="image.status=='delivered'">
            <v-col cols="6">
              <v-chip color="orange darken-1" text-color="white" small>Validé</v-chip>
            </v-col>
            <v-col cols="6" class="text-right" style="position:relative;z-index:9">
              <v-btn
                x-small
                fab
                dark
                color="primary"
                :href="$assets.meeroOriginal(orderId, image.id)"
                target="_blank"
              >
                <v-icon>mdi-download</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row no-gutters align="end" class="fill-height" v-else>
            <v-col cols="12" class="text-right" style="position:relative;z-index:9">
              <v-btn
                x-small
                fab
                dark
                color="primary"
                v-if="!isSelected(image.id)"
                @click="selectImage(image.id)"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
              <v-btn
                x-small
                fab
                dark
                color="orange darken-1"
                v-if="isSelected(image.id)"
                @click="unselectImage(image.id)"
              >
                <v-icon>mdi-check</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>

        <v-expand-transition>
          <div
            class="d-flex flex-column transition-fast-in-fast-out v-card--reveal white--text"
            style="height: 100%;"
            v-if="hover"
            @click="zoom=true"
          >
            <v-icon x-large color="white">mdi-magnify-plus-outline</v-icon>
          </div>
        </v-expand-transition>
      </v-img>
      <v-dialog v-model="zoom">
        <v-card>
          <v-img
            :src="$assets.meeroThumbnail(orderId, image.id)"
            contain="true"
            max-height="800"
            lazy-src="../../assets/lazy-src.jpg"
          ></v-img>
        </v-card>
      </v-dialog>
    </v-card>
  </v-hover>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data: () => ({
    zoom: false
  }),
  props: {
    orderId: {
      type: Number,
      required: true
    },
    image: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters("album", ["isSelected"])
  },
  methods: {
    ...mapActions("album", ["selectImage", "unselectImage"])
  }
};
</script>

<style lang="less" scoped>
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  position: absolute;
  width: 100%;
}
.v-card--reveal {
  background-color: rgba(10, 37, 44, 0.4);
}
</style>